<template>
  <transition name="fade">
    <div
      class="c-header-search-window-desktop js-ignore-click-event"
      :style="position"
    >
      <div class="c-header-search-window-desktop__left-column">
        <div v-show="recentSearches.length">
          <h3 class="c-header-search-window-desktop__title">
            検索履歴から探す
          </h3>
          <ul class="c-header-search-window-desktop__recent-searches">
            <li
              class="c-header-search-window-desktop__recent-search"
              v-for="recentSearch in recentSearches"
              :key="recentSearch"
            >
              <header-link
                deletable
                :link-item="recentSearch"
                icon-name="clock"
                :mark-word="markWord"
                @delete-clicked="$emit('delete-clicked', recentSearch)"
              ></header-link>
            </li>
          </ul>
        </div>

        <div v-show="querySuggestions.length">
          <h3 class="c-header-search-window-desktop__title">
            人気検索キーワードから探す
          </h3>
          <ul class="c-header-search-window-desktop__query-suggestions">
            <li
              class="c-header-search-window-desktop__query-suggestion"
              v-for="querySuggestion in querySuggestions"
              :key="querySuggestion"
            >
              <header-link
                :link-item="querySuggestion"
                icon-name="search"
                :mark-word="markWord"
              ></header-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="c-header-search-window-desktop__right-column">
        <h3 class="c-header-search-window-desktop__title">
          オススメ商品から探す
        </h3>
        <ul
          v-if="products.length"
          class="c-header-search-window-desktop__products"
        >
          <li
            v-for="product in products"
            :key="product.id"
            class="c-header-search-window-desktop__product"
          >
            <f-product-card
              :mark-word="markWord"
              :product="product"
              size="small"
              :should-get-review="true"
            ></f-product-card>
          </li>
        </ul>
        <div v-else class="c-header-search-window-desktop__text">
          アイテムが見つかりませんでした。他のキーワードでお試しください。
        </div>

        <div v-if="articleItems.length">
          <h3 class="c-header-search-window-desktop__title">
            特集・コーディネート
          </h3>
          <ul class="c-header-search-window-desktop__linkItems">
            <li
              v-for="articleItem in articleItems"
              :key="articleItem.id"
              class="c-header-search-window-desktop__linkItem"
            >
              <header-link-card
                :link-item="articleItem"
                :mark-word="markWord"
              ></header-link-card>
            </li>
          </ul>
        </div>

        <div v-if="collectionItems.length">
          <h3 class="c-header-search-window-desktop__title">
            カテゴリ・コレクション
          </h3>
          <ul class="c-header-search-window-desktop__linkItems">
            <li
              v-for="collectionItem in collectionItems"
              :key="collectionItem.id"
              class="c-header-search-window-desktop__linkItem"
            >
              <a
                :href="collectionItem.url"
                class="c-header-search-window-desktop__link"
              >
                {{ collectionItem.title }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import HeaderLink from '~/js/components/header/link'
import HeaderLinkCard from '~/js/components/header/linkCard'
import FProductCard from '~/js/components/productCard'

export default {
  name: 'ComponentHeaderSearchWindowDesktop',
  components: {
    HeaderLink,
    HeaderLinkCard,
    FProductCard,
  },
  props: {
    articleItems: { type: Array, default: () => [] },
    collectionItems: { type: Array, default: () => [] },
    querySuggestions: { type: Array, default: () => [] },
    recentSearches: { type: Array, default: () => [] },
    products: { type: Array, default: () => [] },
    markWord: { type: String, default: '' },
    position: {
      type: Object,
      default: () => {
        return {
          top: 0,
          height: '100%',
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';

.c-header-search-window-desktop {
  display: flex;
  position: fixed;
  right: 0;
  left: 0;
  margin: auto;
  max-width: 100%;
  width: variables.$width-section;
  padding: 48px;
  border-radius: 20px;
  box-shadow: 0px 0px 2px 2px rgba(#ababab, 0.25);
  background-color: variables.$color-pink;
  z-index: variables.$z-index-header + 1;
  transition: opacity 0.3s;
  overflow: scroll;

  &__left-column {
    flex-grow: 1;
  }

  &__right-column {
    flex-shrink: 0;
    margin-left: 24px;
    width: 800px;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
  }

  &__recent-searches,
  &__query-suggestions,
  &__products,
  &__linkItems,
  &__text {
    margin: 16px 0 40px;
  }

  &__recent-search,
  &__query-suggestion {
    margin: 4px 0;
  }

  &__products {
    display: flex;
    overflow-x: scroll;
  }

  &__product {
    width: variables.$width-product-card-default;

    & + & {
      margin-left: 20px;
    }
  }

  &__linkItems {
    background-color: #fff;
    border-radius: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 12px;
  }

  &__linkItem {
    padding: 12px;
    width: 50%;
  }

  &__link {
    display: block;
    font-weight: 600;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    :deep(em) {
      background-color: variables.$color-pink;
      padding: 2px;
    }
  }

  &.fade-enter-from,
  &.fade-leave-to {
    opacity: 0;
  }
}
</style>
